// extracted by mini-css-extract-plugin
module.exports = {"container":"Icon-container-2kfvE","isActive":"Icon-isActive-2yTIt","colorWhite":"Icon-colorWhite-2YAdJ","icon":"Icon-icon-3hMHq","colorBlack":"Icon-colorBlack-15s7N"};